<script setup lang="ts">
// import { Flip } from 'gsap/Flip'

// Register additional GSAP plugin(s) once at app level using v-gsap-nuxt's shared instance
// onBeforeMount(() => {
//   useGSAP().registerPlugin(Flip)
// })
</script>

<template>
  <UApp>
    <TheDraftModeBanner />
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator color="#000" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!--    <TheSubscribeModal />-->
    <ClientOnly>
      <CookieBanner />
    </ClientOnly>
  </UApp>
</template>
